<div class="modern-section appearance-{{ appearance }} state-{{ state }}" [class.expanded]="expanded" [class.animated]="animated">
  <div class="modern-section-header" (click)="toggle()" [class.collapsible]="collapsible">
    <div class="modern-section-header--left">
      <div class="modern-section-toggle">
        @if(expanded) {
          <span class="fa fa-caret-down"></span>
        } @else {
          <span class="fa fa-caret-right"></span>
        }
      </div>
      <div class="modern-section-title">{{ title }}</div>
      <ng-content select="[left-section-title]"></ng-content>
    </div>
    <div class="modern-section-header--right">
      <ng-content select="[right-section-title]"></ng-content>
    </div>
  </div>
  <div class="modern-section-body">
    <div class="modern-section-body-inner" [class.modern-section-body-padding]="hasBodyPadding">
      <ng-content></ng-content>
    </div>
  </div>
</div>
